import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const departmentAppOperation = {
  namespaced: true,

  state: () => ({
    loading: false,
    departmentAppOperationRegistrationSuccess: false,
    departmentAppOperationRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _departmentAppOperationRegistrationSuccess: state =>
      state.departmentAppOperationRegistrationSuccess,
    _departmentAppOperationRegistrationFailure: state =>
      state.departmentAppOperationRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    DepartmentOperation_REGISTRATION_SUCCESS (state, value) {
      state.departmentAppOperationRegistrationSuccess = value
    },
    DepartmentOperation_REGISTRATION_FAILURE (state, value) {
      state.departmentAppOperationRegistrationFailure = value
    }
  },

  actions: {
    CreateDepartmentOperation ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/DepartmentAppOperation/CreateDepartmentOperation', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('DepartmentOperation_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('DepartmentOperation_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    RemoveDepartmentOperation ({ commit, rootState, dispatch }, DepartmentAppOperationId) {
      return new Promise((resolve, reject) => {
        commit('LOADING', true)
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .get(
            `/DepartmentAppOperation/RemoveDepartmentAppOperation?DepartmentAppOperationId=${DepartmentAppOperationId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetDepartmentOperation ({ rootState, commit, dispatch }, DepartmentAppOperationId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            `/DepartmentAppOperation/GetDepartmentAppOperation?DepartmentAppOperationId=${DepartmentAppOperationId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllOperationByDepartment ({ rootState, commit, dispatch }, departmentId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            `/DepartmentAppOperation/GetAllOperationByDepartment?departmentId=${departmentId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllDepartmentAppOperation ({ rootState, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            '/DepartmentAppOperation/GetAllDepartmentAppOperation',
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default departmentAppOperation
